module.exports = __webpack_public_path__ + "static/03-1d84d53af64a37ef3a0c1ba49196a05b.jpg";